export const ShippingCarrierIds = {
  beMondialRelayPickup: 'carrier.be-mondialrelay-pickup.001',
  bePostEvening: 'carrier.be-bpost-evening.001',
  bePostHome: 'carrier.be-bpost-home.001',
  bePostPoints: 'carrier.be-bpost-points.001',
  itNone: 'carrier.it-none.001',
  oneDayDelivery: 'carrier.onedaydelivery.001',
  postNlHome: 'carrier.postnl.001',
  postNlPoints: 'carrier.postnl-points.001',
} as const

export type ShippingCarrierIds =
  (typeof ShippingCarrierIds)[keyof typeof ShippingCarrierIds]
